// =============================================================================
// Modal wrapper for RoomPicker: "Which room do you want to add?"
// Single-select: used by Inventory. Multi-select: used by Checklist creation.
// =============================================================================

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { RoomPicker } from "./RoomPicker";
import type { PropertyRoom } from "@/hooks/usePropertyRooms";

export interface RoomPickerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  propertyId: string;
  mode: "single" | "multi";
  /** For multi mode: pre-selected room ids */
  selectedIds?: string[];
  /** Called with selected room(s). Modal closes after. */
  onSelect: (rooms: PropertyRoom[]) => void;
  title?: string;
  prompt?: string;
}

export function RoomPickerModal({
  open,
  onOpenChange,
  propertyId,
  mode,
  selectedIds = [],
  onSelect,
  title = "Add room",
  prompt = "Which room do you want to add?",
}: RoomPickerModalProps) {
  const handleSelect = (rooms: PropertyRoom[]) => {
    onSelect(rooms);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <RoomPicker
          propertyId={propertyId}
          mode={mode}
          selectedIds={selectedIds}
          onSelect={handleSelect}
          prompt={prompt}
        />
      </DialogContent>
    </Dialog>
  );
}
